export default __webpack_public_path__ + "static/media/yuryu-07.4ae8e4ff.svg";